import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import MainDashboard from './pages/main-dashboard';
import HistoricalDataExplorer from './pages/historical-data-explorer';
import RealTimeOrderBook from './pages/real-time-order-book';
import NewsAndEvents from './pages/news-and-events';
import StrategyBuilder from './pages/strategy-builder';
import ComplianceDashboard from './pages/compliance-dashboard';
import MarketAnalysis from './pages/market-analysis';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<ComplianceDashboard />} />
        <Route path="/main-dashboard" element={<MainDashboard />} />
        <Route path="/historical-data-explorer" element={<HistoricalDataExplorer />} />
        <Route path="/real-time-order-book" element={<RealTimeOrderBook />} />
        <Route path="/news-and-events" element={<NewsAndEvents />} />
        <Route path="/strategy-builder" element={<StrategyBuilder />} />
        <Route path="/compliance-dashboard" element={<ComplianceDashboard />} />
        <Route path="/market-analysis" element={<MarketAnalysis />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
